/// <amd-module name="Release/Sharedcontributions/RunActionService" />
import { BuildResult, BuildStatus } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";

import { IReleaseMenuService } from "Release/Sharedcontributions/ReleaseMenuService";

import { IBuildReleaseDefinitionProvider } from "Release/Helpers/BuildReleaseDefinitionProvider";
import * as Resources from "Release/Sharedcontributions/Resources";
import { IObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";

interface IRunActionProps {
    status: BuildStatus;
    result: BuildResult;
    runId: number;
    pipelineId: number;
    projectId: string;
}

export class RunActionService extends VssService implements IMenuService {
    private _items: IObservableArray<IHeaderCommandBarItem> = new ObservableArray<IHeaderCommandBarItem>();
    private _releaseDefinitionProvider: IBuildReleaseDefinitionProvider;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._releaseDefinitionProvider = pageContext.getService<IBuildReleaseDefinitionProvider>("IBuildReleaseDefinitionProvider");
    }

    public getMenuItems(menuId: string, contextualData?: IRunActionProps): IObservableArray<IHeaderCommandBarItem> {
        this._items.removeAll();
        if (contextualData && menuId === "ms.vss-build-web.run-actions") {
            this._initializeBuild(contextualData);
        }

        return this._items;
    }

    private async _initializeBuild(data: IRunActionProps) {

        if ((data.result !== BuildResult.Succeeded && data.result !== BuildResult.PartiallySucceeded) || data.status !== BuildStatus.Completed) {
            return;
        }

        const releaseDefinitions =  await this._releaseDefinitionProvider.getReleaseDefinitionsByBuild(data.projectId, data.pipelineId);
        if (releaseDefinitions.length === 0) {
            return;
        }

        const buildClient = this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        const build = await buildClient.getBuild(data.projectId, data.runId);
        this._items.push({
            id: "run-release-action",
            text: Resources.Release,
            important: false,
            onActivate: () => {
                const service = this.pageContext.getService<IReleaseMenuService>("release-menu-service");
                service.createRelease(build);
            }
        });
    }
}

Services.add("release-run-action-service", { serviceFactory: RunActionService });
